import md5 from 'md5'

function getEncodedKey (key) {
  return md5(key)
}

function setStorageValue (storage, key, val) {
  const encodedKey = getEncodedKey(key)
  if (val === '' || val === null || typeof val === 'undefined') {
    storage.removeItem(encodedKey)
    return
  }
  storage.setItem(encodedKey, window.btoa(String(val)))
}

function getStorageValue (storage, key) {
  const item = storage.getItem(getEncodedKey(key))
  let decodedValue = ''
  try {
    decodedValue = window.atob(item)
  } catch (e) {
    console.log(e)
    decodedValue = ''
  }
  return item === null ? '' : decodedValue
}

function removeStorageValue (storage, key) {
  storage.removeItem(getEncodedKey(key))
}

function setLocalStorage (key, val) {
  setStorageValue(window.localStorage, key, val)
}

function getLocalStorage (key) {
  return getStorageValue(window.localStorage, key)
}

function removeLocalStorage (key) {
  removeStorageValue(window.localStorage, key)
}

function setSessionStorage (key, val) {
  setStorageValue(window.sessionStorage, key, val)
}

function getSessionStorage (key) {
  return getStorageValue(window.sessionStorage, key)
}

function removeSessionStorage (key) {
  removeStorageValue(window.sessionStorage, key)
}

function getUserInfo () {
  const userInfo = getLocalStorage('userInfo')
  if (userInfo === null) return ''
  try {
    return JSON.parse(userInfo)
  } catch (e) {
    return ''
  }
}

function setUserInfo (data) {
  setLocalStorage('userInfo', data ? JSON.stringify(data) : '')
}

function setMerchantIdentity (merchantIdentity) {
  setSessionStorage('MerchantIdentity', merchantIdentity)
}

function getMerchantIdentity () {
  return getSessionStorage('MerchantIdentity') || getLocalStorage('MerchantIdentity')
}

function getSyncFlag () {
  const syncFlag = getCookie('SyncFlag')
  if (syncFlag === '') {
    setCookie('SyncFlag', 'AllReady', 9999999)
    return 'True'
  }
  return 'False'
}

// 获取 Cookie
function getCookie (cName) {
  cName = md5(cName)
  if (document.cookie.length > 0) {
    let cStart = document.cookie.indexOf(cName + '=')
    if (cStart !== -1) {
      cStart = cStart + cName.length + 1
      let cEnd = document.cookie.indexOf(';', cStart)
      if (cEnd === -1) cEnd = document.cookie.length
      let decodedValue = ''
      try {
        decodedValue = window.atob(unescape(document.cookie.substring(cStart, cEnd)))
      } catch (e) {
        console.log(e)
        decodedValue = ''
      }
      return decodedValue
    }
  }
  return ''
}

// 保存 Cookie
function setCookie (name, val, day) {
  name = md5(name)
  val = window.btoa(String(val))
  const exDate = new Date()
  exDate.setDate(exDate.getDate() + day)
  document.cookie = name + '=' + escape(val) +
    ((day == null) ? '' : ';expires=' + exDate.toGMTString() + '; path=/')
}

function getUserToken () {
  return getSessionStorage('token') || getCookie('token')
}

function setUserToken (val) {
  setSessionStorage('token', val)
  setCookie('token', '', -1)
  if (!val) {
    removeSessionStorage('token')
  }
}

function isValidDate (d) {
  return d instanceof Date && !isNaN(d)
}

function setRuntimeCache (key, data) {
  setSessionStorage(key, JSON.stringify(data))
}

function getRuntimeCache (key) {
  const cache = getSessionStorage(key)
  if (!cache) return null
  try {
    return JSON.parse(cache)
  } catch (e) {
    console.log(e)
    removeSessionStorage(key)
    return null
  }
}

function removeRuntimeCache (key) {
  removeSessionStorage(key)
}

function addmatomo (eventId, key, value) {
  if (window.ucityApp && typeof (window.ucityApp.tryAutomatomo) === 'function') {
    window.ucityApp.tryAutomatomo(eventId, key, value)
  } else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.UcityApp_matomo && typeof (window.webkit.messageHandlers.UcityApp_matomo.postMessage) === 'function') {
    const obj = {}
    obj.channel = 'matomo'
    obj.eventId = eventId
    obj.key = key
    obj.value = value
    window.webkit.messageHandlers.UcityApp_matomo.postMessage(obj)
  } else {
    console.log('eventId:' + eventId + ' key:' + key + ' value:' + value)
  }
}

export default {
  md5,
  setLocalStorage,
  getLocalStorage,
  removeLocalStorage,
  setSessionStorage,
  getSessionStorage,
  removeSessionStorage,
  setUserInfo,
  getUserInfo,
  getUserToken,
  setUserToken,
  getMerchantIdentity,
  setMerchantIdentity,
  setCookie,
  getCookie,
  isValidDate,
  getSyncFlag,
  setRuntimeCache,
  getRuntimeCache,
  removeRuntimeCache,
  addmatomo
}
